import { Component ,Input} from '@angular/core';
import { NgxCarousel } from 'ngx-carousel';

import { NewsService } from '../../services/newsService'

@Component({
    selector: 'NewPromotion',
    template: `
    <ngx-carousel 
        (mouseover)="show('slide-button')"
        (mouseout)="hide()"
        [inputs]="carouselOne">

        <ngx-item NgxCarouselItem *ngFor="let Advertise of dataAdvertisement; let i = index;">
            <div class="image_slide">
                <img class="w-100 imgbrand" src="{{Advertise.pathimg}}" style=""/>
            </div>            
        </ngx-item>


        <button NgxCarouselPrev class='leftRs' style='margin-left: 40px;'
            [ngStyle]="hoverDivName ==='slide-button' ? showDiv : hideDiv">
            <img class="w-100" src="/assets/img/chevron_left_white.png" />
        </button>
        <button NgxCarouselNext class='rightRs' style='margin-right: 40px;'
            [ngStyle]="hoverDivName ==='slide-button' ? showDiv : hideDiv">
            <img class="w-100" src="/assets/img/chevron_right_white.png" />
        </button>
    </ngx-carousel>
  `,
  styles: [`
  .px-button-buy{
    font-size: 1rem;
    padding-left: 3rem;
    padding-right: 3rem;
  }
    .pt-edit-newspromo{
        padding-top: 2rem;
        padding-bottom: 1rem;
    }
    .headertext{
        color:#ffe082;
        font-size: 3rem;
    }
    .headerDetail{
        color: #fff;
        font-size: 1.7rem;
    }
    .detailText{
        color:#fff;
        font-size:1rem;
    }
    .dateEndText{
        color:#fff;
        font-size:0.6rem;
    }
    .image_text{
        position: absolute;
        height: 400px;
        width: 30rem;
        margin-left: 5rem;
    }
    .image_slide{
        width: 100%;
        height: auto;
        background-color:gray;
    }
    .leftRs {
        position: absolute;
        margin: auto;
        top: 0;
        bottom: 0;
        width: 50px;
        height: 50px;
        box-shadow: 1px 2px 10px -1px rgba(0, 0, 0, .3);
        border-radius: 999px;
        left: 0;
        border: 0;
        background-color: rgba(0, 0, 0, 0.45);
        opacity:0;
        transition:all 0.5s;
    }
    .rightRs {
        position: absolute;
        margin: auto;
        top: 0;
        bottom: 0;
        width: 50px;
        height: 50px;
        box-shadow: 1px 2px 10px -1px rgba(0, 0, 0, .3);
        border-radius: 999px;
        right: 0;
        border: 0;
        background-color: rgba(0, 0, 0, 0.45);
        opacity:0;
        transition:all 0.5s;
    }
    li.active{
        background: rgba(27, 30, 33, 0.61);
    }
    ul.ngxcarouselPoint {
        position: absolute;
        width: 100%;
        bottom: 47px !important;
        margin-top: -40px;
        z-index: 0;
    }
    @media (min-width: 992px) and (max-width: 1199px) {
        .image_text{
            width: 30rem;
        }
        .image_slide[_ngcontent-c4] {
            height: 315px;
        }
        .headertext {
            color: #ffe082;
            font-size: 2rem;
        }
        .headerDetail{
            color: #fff;
            font-size: 1.2rem;
        }
        .image_text[_ngcontent-c4] {
            position: absolute;
            height: 400px;
            width: 30rem;
            margin-left: 2rem;
        }
      }
    @media (min-width: 768px) and (max-width: 991px) {
        .image_slide[_ngcontent-c4] {
            height: 236px
        }
        .headertext[_ngcontent-c4] {
            color: #ffe082;
            font-size: 1.5rem;
        }
        .headerDetail[_ngcontent-c4] {
            color: #fff;
            font-size: 1rem;
        }
        .detailText[_ngcontent-c4] {
            color: #fff;
            font-size: 0.7rem;
        }
        .image_text {
            position: absolute;
            height: 400px;
            width: 30rem;
            margin-left: 1rem;
        }
        .pt-edit-newspromo[_ngcontent-c4] {
            padding-top: 1rem;
            padding-bottom: 0.5rem;
        }
        .px-button-buy[_ngcontent-c4] {
            font-size: 0.8rem;
            padding-left: 2rem;
            padding-right: 2rem;
        }
    }
    @media (max-width: 767px) {
        .image_text {
            height: 137px;
            width: 12rem;
            margin-left: 1rem;
        }
        .image_slide{
            height: 123px;
        }
        .headertext{
            color: #ffe082;
            font-size: 0.8rem;
        }
        .headerDetail{
            color: #fff;
            font-size: 0.5rem;
        }
        .detailText {
            color: #fff;
            font-size: 0.4rem;
        }
        .pt-edit-newspromo[_ngcontent-c4] {
            padding-top: 0.5rem;
            padding-bottom: 0.1rem;
        }
        .dateEndText[_ngcontent-c4] {
            color: #fff;
            font-size: 0.2rem;
        }
        .px-button-buy[_ngcontent-c4] {
            font-size: 0.5rem;
            padding-left: 0.5rem;
            padding-right: 0.5rem;
            padding-top: 0.2rem;
            padding-bottom: 0.2rem;
        }
    }
  `]
})
export class PomotionNews {

    @Input() links :string

    public carouselOne: NgxCarousel;
    public showSelect: boolean;
    public showAdd: boolean;
    private items: number[] = [];

    public dataAdvertisement;
    constructor(private nSv: NewsService) {
        
        let dataAd = this.nSv.getAdvertise()
        dataAd.subscribe((snap)=>{
            this.dataAdvertisement = snap
        })
         
        this.carouselOne = {
            grid: { xs: 1, sm: 1, md: 1, lg: 1, all: 0 },
            slide: 1,
            speed: 400,
            interval: 4000,
            point: {
                visible: true
            },
            load: 2,
            touch: true,
            loop: true,
            custom: 'banner'
        }
    }
  
    // opacity ปุ่ม slide //
    hoverDivName;
    hideDiv = {opacity:'0'};
    showDiv= {opacity:'1'};

    show(divName:string){
        this.hoverDivName = divName;
    }

    hide(divName:string){
        this.hoverDivName = null;
    }
    


}


// WEBPACK FOOTER //
// D:/pokpak-v3/pokpak-v2/pokpak-ang/src/app/components/carousel/news-promotion.ts